import h from 'hyperscript';
import plusIcon from '@disy/cadenza-icons/plus.svg';

import i18n from 'ui/attribute-list/attribute-list.properties';
import { createButton } from 'ui/button/button';

import { icon } from 'cadenza/utils/icon/icon';

import { openAddDataDialog } from 'cadenza/workbook/workbook-panel/databrowser/open-add-data-dialog';

export function createEmptyListContent() {
  const isAddingDataAllowed = document.querySelector('.d-workbook[adding-data-allowed=true]') != null;
  return h(
    '.d-stack-v.space-3',
    h('d-alert', { type: 'info', size: 's' }, i18n('empty')),
    isAddingDataAllowed ?
      createButton([icon(plusIcon), i18n('addData')], {
        variant: 'primary',
        onclick: () => openAddDataDialog(),
      })
    : h('d-alert.d-alert-small', { type: 'info' }, i18n('addDataNotAllowed')),
  );
}
